module.exports = __webpack_public_path__ + "static/media/PlinkoPopup.600e020a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PlinkoPopup.png
// module id = 687
// module chunks = 0